$(document).ready(function(){
	if($(".wgoTopArea").next().attr("class")=="wgoThumbnail")
		$(".wgoTopArea").next().attr("class","row");
	
	
	var tind = 1;
	$('.wgoThumb div img').each(function(){
		$(this).attr("id","wgoThumb_"+tind);
		tind++
	});
	var find = 1;
	$('.simpleGal div img').each(function(){
		$(this).addClass("image_"+find);
		find++
	});

    // Image Zoom
    $('.option-image .zoom .sfimageWrp').zoom();
	//$('#ex2').zoom({ on:'grab' });
	//$('#ex3').zoom({ on:'click' });			 
    //$('#ex4').zoom({ on:'toggle' });
    
    // wgoThumbnails
    $('.option-image').simpleGal({
        galltime : 400,
		gallcontent : '.simpleGal',
		gallwgoThumbnail : '.simpleGal .wgoThumbnail',
		gallwgoThumb : '.wgoThumb .sfimageWrp'
    });
    
    if ($(".wgoTabWrap").html() && $(".wgoTabWrap").html().indexOf("Integer posuere ullamcorper") > 0)
        $(".wgoTabWrap").hide();

    $('.wgoTabTitles .tab').click(function(){
        var ind = $(this).index();
        $('.wgoTabTitles .tab').each(function(){
            if ($(this).index() == ind) {
                $(this).addClass("tab-active");
            } else {
                $(this).removeClass("tab-active");
            }
        });
        $('.wgoTabContent .tab').each(function(){
            if ($(this).index() == ind) {
                $(this).addClass("tab-active");
            } else {
                $(this).removeClass("tab-active");
            }
        });
    });
    
});